enum LawLabelLinkEnum {
	LABEL_LAW_LABEL_EN = 'Law Label',
	LABEL_LAW_LABEL_ES = 'Etiqueta normativa'
}

export default LawLabelLinkEnum;
